// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"1fc8ac863c88c4a791a8","9777":"bee82609820ddcefea2e"}[chunkId] + ".js");